import EventAssignmentFormPage from '@/pages/events/assignment-form'
import { WorkspacePortalProvider } from '@/contexts/workspace-portal-context'

export default function EventAssignmentCreatePage() {
  return (
    <WorkspacePortalProvider mode="event">
      <EventAssignmentFormPage />
    </WorkspacePortalProvider>
  )
}
